<template>
  <blockquote class="relative bg-gray-50 p-2 pl-4 before:absolute before:inset-y-0 before:left-0 before:w-2 before:bg-gray-200">
    <slot />
  </blockquote>
</template>
